import {z} from 'zod';

import i18n from '@dms/i18n';

const docSeriesSchema = z.object({
  docSeriesId: z.string().nonempty({message: i18n.t('errors.field_is_required')}),
});

const dayMonthSchema = z.object({
  month: z.number(),
  day: z.number(),
});

export const tiresInventoryFormSchema = z.object({
  name: z.string().nonempty({message: i18n.t('errors.field_is_required')}),
  branchIds: z.array(z.string()).min(1, {message: i18n.t('errors.field_is_required')}),
  documentSettings: z.object({
    receiptNote: docSeriesSchema,
    issueNote: docSeriesSchema,
    archiveNote: docSeriesSchema,
    tireOrder: docSeriesSchema,
    tireSet: docSeriesSchema,
  }),
  hasAutomaticStoreUntilSettings: z.boolean(),
  storeUntilSettings: z
    .array(
      z
        .object({
          receivedAt: dayMonthSchema.nullable(),
          receivedTo: dayMonthSchema.nullable(),
          preFillDate: dayMonthSchema.nullable(),
        })
        .nullable()
    )
    .optional(),
});

export type TiresInventoryFormType = z.infer<typeof tiresInventoryFormSchema>;
